import React from 'react';
import { Link } from 'react-router-dom';
import { Pane, Heading, Paragraph, Button } from 'evergreen-ui';

function ThankYou() {
  return (
    <Pane
      display="flex"
      alignItems="center"
      justifyContent="center"
      height="100vh"
      background="tint2"
    >
      <Pane
        background="white"
        padding={40}
        borderRadius={8}
        maxWidth={500}
        textAlign="center"
        elevation={1}
      >
        <Heading size={900} marginBottom={20}>
          Thank You for Trying WorkingLit
        </Heading>
        <Paragraph size={500} marginBottom={30}>
          <Link to="https://forms.gle/Nz2WtfUiJY9mvjts8" style={{ textDecoration: 'none' }}>
            <Button appearance="primary" height={40} >
            We would love to hear your feedback
          </Button>
          </Link>
        </Paragraph>
        <Paragraph size={500} marginBottom={30}>
          We appreciate the time you spent with us. If you ever want to return,
          you're always welcome to create a new account.
        </Paragraph>
        <Link to="/login" style={{ textDecoration: 'none' }}>
          <Button appearance="primary" height={40}>
            Return to Registration
          </Button>
        </Link>
      </Pane>
    </Pane>
  );
}

export default ThankYou;
